import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { useSearchIcd10Codes } from "@/clinical-codes/useSearchIcd10Codes";

export const useTransformationQueries = () => {
  const { codes: icd10Codes } = useSearchIcd10Codes();
  // TODO: Add OPCS-4 codes

  const { data: fields } = useQuery({
    queryKey: ["fields"],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("fields")
        .select(
          `
          *,
          primary_dataset:datasets!fields_primary_dataset_id_fkey(*)
        `,
        )
        .order("name", { ascending: true });

      if (error) throw error;
      return data;
    },
  });

  const { data: datapoints } = useQuery({
    queryKey: ["datapoints"],
    queryFn: async () => {
      const { data, error } = await supabase.from("datapoints").select("*").order("name", { ascending: true });

      if (error) throw error;
      return data;
    },
  });

  return {
    fields,
    icd10Codes,
    datapoints,
  };
};
